<template>
    <div>
        <legend class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Sprachkenntnisse:') }}
        </legend>
        <table class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Sprache') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Spracheniveau') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="spokenLanguage in spokenLanguages"
                    :key="spokenLanguage.id"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td class="kgr-table__cell">
                        <template>{{ spokenLanguage.language.name }}</template>
                    </td>
                    <td class="kgr-table__cell">
                        <template v-if="isBeingEdited(spokenLanguage)">
                            <div class="form-widget without-label">
                                <kgr-language-level-picker
                                    v-model="editLanguages[getEditIndex(spokenLanguage)].level"
                                />
                            </div>
                            <div
                                v-if="editLanguages[getEditIndex(spokenLanguage)].level === null"
                            >
                                {{ getErrorMessageForLevel(editLanguages[getEditIndex(spokenLanguage)]) }}
                            </div>
                        </template>
                        <template v-else>
                            {{ $t('language.' + spokenLanguage.level) }}
                        </template>
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--actions">
                        <kgr-icon-edit
                            :size="15"
                            :disabled="isBeingEdited(spokenLanguage)"
                            class="kgr-table__action"
                            @click="edit(spokenLanguage)"
                        />
                        <kgr-icon-delete
                            class="kgr-table__action"
                            @click="remove(spokenLanguage)"
                        />
                    </td>
                </tr>

                <tr class="kgr-table__row kgr-table__row--top">
                    <td class="kgr-table__cell">
                        <div class="form-widget without-label">
                            <kgr-language-picker
                                :key="addLanguage"
                                v-model="newSpokenLanguage.language"
                            />
                        </div>
                    </td>
                    <td class="kgr-table__cell">
                        <div class="form-widget without-label">
                            <kgr-language-level-picker
                                :key="addLanguage"
                                v-model="newSpokenLanguage.level"
                                @change="changedSpokenLanguageLevel"
                            />
                        </div>
                        <div
                            v-if="newSpokenLanguageIsInvalid"
                            class="form-widget error"
                        >
                            {{ getErrorMessageForLevel(newSpokenLanguage) }}
                        </div>
                    </td>
                    <td class="kgr-table__cell">
&nbsp;
                    </td>
                </tr>
            </tbody>
        </table>
        <kgr-button
            class="button_save"
            :value="$t('saveChanges')"
            :pending="pendingCreate || pendingUpdate"
            @click="save()"
        />
    </div>
</template>

<script>
import EmployeeRepository from '../../../js/repository/EmployeeRepository';
import Error from '../../../js/model/Error';
import IconDelete from '../../common/icon/IconDelete.vue';
import IconEdit from '../../common/icon/IconEdit.vue';
import KgrButton from '../../common/form/button/KgrButton.vue';
import LanguageLevelSelect from '../../common/form/select/LanguageLevelSelect.vue';
import LanguageSelect from '../../common/form/select/LanguageSelect.vue';
import SpokenLanguage from '../../../js/dto/SpokenLanguage';
import axios from 'axios';

export default {
    name: 'SpokenLanguagesForm',
    components: {
        'kgr-language-picker': LanguageSelect,
        'kgr-language-level-picker': LanguageLevelSelect,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
        'kgr-button': KgrButton,
    },
    props: {
        spokenLanguages: {
            type: Array,
            required: true,
        },
        employeeId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            editLanguages: [],
            pendingCreate: false,
            pendingUpdate: false,
            newSpokenLanguage: new SpokenLanguage(),
            newSpokenLanguageIsInvalid: false,
            alertMessages: [],
            addLanguage: 0,
            error: new Error(),
        }
    },
    methods: {
        isBeingEdited(spokenLanguage) {
            return this.getEditIndex(spokenLanguage) !== -1;
        },
        getEditIndex(spokenLanguage) {
            return this.editLanguages.map(language => language.id).indexOf(spokenLanguage.id);
        },
        remove(spokenLanguage) {
            showConfirm(this.$t('confirm'), this.$t('Wollen sie wirklich die Sprache {name} löschen?', {'name': spokenLanguage.language.name}), () => {
                this.editLanguages = this.editLanguages.filter(r => r.id !== spokenLanguage.id);
                EmployeeRepository
                    .removeSpokenLanguage(this.employeeId, spokenLanguage.id)
                    .then(() => {
                        this.$notify.success('Sprache {name} erfolgreich gelöscht.', {'name': spokenLanguage.language.name});
                        this.emitUpdated();
                    })
                    .catch(() => {
                        this.$notify.error('saveChanges.error');
                    });
            }, 'Ok');
        },
        edit(spokenLanguage) {
            if (this.isBeingEdited(spokenLanguage)) {
                return;
            }

            this.editLanguages.push(spokenLanguage.toData());
        },
        save() {
            this.pendingCreate = true;
            this.pendingUpdate = true;

            let apiCalls = [];
            if (!this.newSpokenLanguage.isEmptyLanguage()) {
                this.newSpokenLanguageIsInvalid = false;
                apiCalls.push(this._createSpokenLanguage());
            }
            if (this.editLanguages.length > 0) {
                apiCalls.push(this._updateSpokenLanguages(this.editLanguages));
            }
            if (apiCalls.length === 0) {
                this.pendingCreate = false;
                this.pendingUpdate = false;
                return;
            }

            axios.all(apiCalls)
                .then(() => {
                    if (this.alertMessages.length > 0 || this.newSpokenLanguageIsInvalid) {
                        this.alertMessages = this.alertMessages.filter((value, index) => this.alertMessages.indexOf(value) === index);
                        this.$notify.error(this.alertMessages);
                        this.newSpokenLanguageIsInvalid = false;
                    } else {
                        this.$notify.success('saveChanges.success');
                        this.emitUpdated();
                    }
                })
                .finally(() => {
                    this.editLanguages = this.editLanguages.filter(spokenLanguage => spokenLanguage.invalid === true);
                    this.newSpokenLanguage = new SpokenLanguage();
                    this.pendingCreate = false;
                    this.pendingUpdate = false;
                    this.alertMessages = [];
                });
        },
        _createSpokenLanguage() {
            if (this.newSpokenLanguage.level === null) {
                this.newSpokenLanguageIsInvalid = true;
                this.alertMessages.push(this.$t('Bitte wählen Sie ein Sprachniveau aus'));
            } else {
                this.newSpokenLanguageIsInvalid = false;
                return EmployeeRepository
                    .createSpokenLanguage(this.employeeId, this.newSpokenLanguage)
                    .then(() => {
                        this.newSpokenLanguage = new SpokenLanguage();
                        this.newSpokenLanguageIsInvalid = false;
                    })
                    .catch(() => {
                        this.newSpokenLanguageIsInvalid = true;
                        this.alertMessages.push(this.$t('Änderungen konnten nicht gespeichert werden. Bitte überprüfe die markierten Einträge.'));
                    })
            }
        },
        _updateSpokenLanguages(editLanguages) {
            return axios.all(editLanguages.map(spokenLanguage => {
                if (spokenLanguage.level === null) {
                    spokenLanguage.invalid = true;
                    this.alertMessages.push(this.$t('Bitte wählen Sie ein Sprachniveau aus'));
                } else {
                    spokenLanguage.invalid = false;
                    return EmployeeRepository
                        .updateSpokenLanguage(this.employeeId, spokenLanguage)
                        .catch(() => {
                            this.alertMessages.push(this.$t('Änderungen konnten nicht gespeichert werden. Bitte überprüfe die markierten Einträge.'));
                            spokenLanguage.invalid = true;
                        })
                }
            })
            );
        },
        emitUpdated() {
            this.addLanguage++;
            this.$emit('updated');
        },
        getErrorMessageForLevel(spokenLanguage) {
            if (!spokenLanguage.level) {
                return this.$t('Bitte wählen Sie ein Sprachniveau aus');
            }
            return null;
        },
        changedSpokenLanguageLevel() {
            if (this.newSpokenLanguage.level !== null) {
                this.newSpokenLanguageIsInvalid = false;
            }
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.button_save {
    display: block;
    margin-left: auto;
}
</style>
